import { getSharedSiteData } from './albumCatalog';
import accessConfig from '../data/profile-access.json';

const sharedSiteData = getSharedSiteData();
const DEFAULT_ACCESS_CONTROL = accessConfig || sharedSiteData.accessControl || {};
const ACCESS_OVERRIDE_KEY = 'vf_profile_access_override';

export const PROFILE_DEFINITIONS = (sharedSiteData.profiles || []).map((profile) => ({
  slug: profile.slug,
  title: profile.name || profile.slug,
  subtitle: profile.subtitle || '',
  avatar: profile.avatarPath,
}));

// Legacy fallback: email -> profiles
export const PROFILE_ALLOWLIST = {
  // 'someone@example.com': ['sushflix', 'momflix'],
};

const normalize = (value) => (value || '').trim().toLowerCase();

const safeParse = (raw) => {
  try {
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
};

export const getDefaultAccessConfig = () => DEFAULT_ACCESS_CONTROL;

export const getAccessConfig = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_ACCESS_CONTROL;
  }
  const raw = window.localStorage.getItem(ACCESS_OVERRIDE_KEY);
  if (!raw) return DEFAULT_ACCESS_CONTROL;
  const parsed = safeParse(raw);
  if (!parsed || typeof parsed !== 'object') return DEFAULT_ACCESS_CONTROL;
  return {
    ...DEFAULT_ACCESS_CONTROL,
    ...parsed,
    profiles: {
      ...(DEFAULT_ACCESS_CONTROL.profiles || {}),
      ...(parsed.profiles || {}),
    },
  };
};

export const saveAccessOverride = (nextConfig) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(ACCESS_OVERRIDE_KEY, JSON.stringify(nextConfig));
};

export const clearAccessOverride = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(ACCESS_OVERRIDE_KEY);
};

const getRuleForProfile = (accessControl, slug) => accessControl?.profiles?.[slug] || null;

export const hasUserAccessToProfile = (user, profileSlug) => {
  if (!user) return false;
  const accessControl = getAccessConfig();
  const email = normalize(user.email);
  const uid = user.uid || '';
  const rule = getRuleForProfile(accessControl, profileSlug);

  // Backward compatibility with old allowlist map.
  const legacyAllowed = PROFILE_ALLOWLIST[email];
  if (legacyAllowed?.includes(profileSlug)) return true;

  if (!rule) {
    return accessControl.allowAllAuthenticatedByDefault !== false;
  }

  const emails = (rule.emails || []).map(normalize);
  const uids = (rule.uids || []).map((entry) => String(entry || '').trim());
  const hasConfiguredRules = emails.length > 0 || uids.length > 0;

  if (!hasConfiguredRules) {
    return accessControl.allowAllAuthenticatedByDefault !== false;
  }

  return emails.includes(email) || uids.includes(uid);
};

export const getAllowedProfiles = (user) => (
  PROFILE_DEFINITIONS.filter((profile) => hasUserAccessToProfile(user, profile.slug))
);
